import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';
import type { AnimalListItem, AnimalDetail } from './animal.service';

export interface DashboardStats {
  usersCount: number;
  animalsCount: number;
  farmsCount: number;
  regionsCount: number;
}

export interface UserListItem {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  createdAt: string;
  isEmailVerified: boolean;
}

export interface CreateUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: number;
}

export interface FarmOption {
  id: number;
  userId: number;
  name: string;
  regionId: number | null;
  region?: { id: number; nameRu: string; nameKz: string; nameEn: string };
}

export interface CreateAnimalRequest {
  animalTypeId?: number | null;
  farmId?: number | null;
  identifierNumber: string;
  registrationNumber?: string | null;
  inventoryNumber?: string | null;
  name?: string | null;
  chipNumber?: string | null;
  birthDate?: string | null;
  breedId?: number | null;
  lineId?: number | null;
  lineName?: string | null;
  birthPlace?: string | null;
  birthWeight?: number | null;
  weaningDate?: string | null;
  weaningWeight?: number | null;
  weight12m?: number | null;
  isBreeding?: boolean | null;
  hasHorns?: boolean;
  sex?: number | null;
  categoryName?: string | null;
  fatherId?: string | null;
  motherId?: string | null;
  statusId?: number | null;
  classId?: number | null;
  breedPurity?: number | null;
}

export const adminService = {
  getDashboard(): Promise<{ success: boolean; data?: DashboardStats; message?: string }> {
    return httpClient.get<DashboardStats>(API_ENDPOINTS.ADMIN.DASHBOARD);
  },

  getUsers(): Promise<{ success: boolean; data?: UserListItem[]; message?: string }> {
    return httpClient.get<UserListItem[]>(API_ENDPOINTS.ADMIN.USERS);
  },

  createUser(
    body: CreateUserRequest
  ): Promise<{ success: boolean; data?: UserListItem; message?: string }> {
    return httpClient.post<UserListItem>(API_ENDPOINTS.ADMIN.USERS, body);
  },

  getFarms(): Promise<{ success: boolean; data?: FarmOption[]; message?: string }> {
    return httpClient.get<FarmOption[]>(API_ENDPOINTS.ADMIN.FARMS);
  },

  createAnimal(
    body: CreateAnimalRequest
  ): Promise<{ success: boolean; data?: unknown; message?: string }> {
    return httpClient.post(API_ENDPOINTS.ADMIN.ANIMALS, body);
  },

  getAnimals(includeDeleted = false): Promise<{ success: boolean; data?: AnimalListItem[]; message?: string }> {
    return httpClient.get<AnimalListItem[]>(`${API_ENDPOINTS.ADMIN.ANIMALS}?includeDeleted=${includeDeleted}`);
  },

  getAnimalById(id: string): Promise<{ success: boolean; data?: AnimalDetail; message?: string }> {
    return httpClient.get<AnimalDetail>(`${API_ENDPOINTS.ADMIN.ANIMALS}/${id}`);
  },
};
